import { cn } from '@snowball-tech/fractal/dist/src/styles/helpers'

import type { ChildrenProps } from '../types'

import PaperBlock from './PaperBlock'

type Props = {
  className?: string
  color?: 'black' | 'body' | 'primary' | 'secondary' | 'transparent'
  withBlock?: boolean
} & ChildrenProps
export default function ColoredScreen({
  children,
  className,
  color = 'primary',
  withBlock = false,
}: Props) {
  let colorClassName = 'bg-primary'
  switch (color) {
    case 'black': {
      colorClassName = 'bg-black'
      break
    }

    case 'body': {
      colorClassName = 'bg-body-light'
      break
    }

    case 'secondary': {
      colorClassName = 'bg-secondary'
      break
    }

    case 'transparent': {
      colorClassName = ''
      break
    }

    default: {
      colorClassName = 'bg-primary'
      break
    }
  }

  return (
    <div
      className={cn(
        `flex h-screen max-h-full w-full items-center justify-center p-3 overflow-y-auto`,
        colorClassName,
        className,
      )}
    >
      {withBlock && <PaperBlock>{children}</PaperBlock>}
      {!withBlock && children}
    </div>
  )
}
